const namespace = 'integrations'

export const GET_INTEGRATIONS = `${namespace}/GET_INTEGRATIONS`;
export const GET_INTEGRATIONS_SUCCESS = `${namespace}/GET_INTEGRATIONS_SUCCESS`;
export const AUTH_GOOGLE_REQUEST = `${namespace}/AUTH_GOOGLE_REQUEST`;
export const AUTH_GOOGLE_SUCCESS = `${namespace}/AUTH_GOOGLE_SUCCESS`;
